module.exports = __webpack_public_path__ + "static/media/Kazakhstan.c95fa7ac.png";